import { React, useCallback, Waiting, observer, useTranslation, css, main } from '../..';
import { useMemo, useContext } from 'react';
import { ToastContext, Button } from '@weezevent/nacre';
import { fetcher } from '@weezevent/weezjs-core';
import AttendeesTable from './Table';
import EmailToggle from './EmailToggle';
import TableError from './Table/TableError';
import { isInvalidEmail } from '../../utils';

const AttendeesStep = observer(() => {
    const { t } = useTranslation();
    const toast = useContext(ToastContext);
    const { event, organization, attendees, messageIsValid, hasQuotas, quotasExceded, remainingQuotas, totalRemaining, payload, parsing, emailToggle, invitationsQuotas } = main;

    const handleSubmit = useCallback(() => {
        main.setSubmit(true);
        payload?.orders?.map(attendee => {
            delete attendee.valid;
        });

        fetcher
            .post(`/ticket/organizations/${organization.id}/events/${event.id}/invitation`, { data: payload })
            .then(() => {
                toast.success(t('partners.invitation.attendees_quickadd.success'));
                main.init({ organization, event });
            })
            .catch(() => {
                toast.error(t('partners.invitation.attendees_quickadd.error'));
            })
            .finally(() => {
                main.setSubmit(false);
                main.init({ organization, event });
            });
    }, [payload, main, organization, event]);

    const missingEmails = useMemo(() => {
        let allEmails = attendees.map(attendee => attendee.email);
        allEmails.pop();
        return allEmails.some(email => !email) && emailToggle;
    }, [attendees, emailToggle, payload]);

    const invalidEmails = useMemo(() => {
        let allEmails = attendees.map(attendee => attendee.email);
        allEmails.pop();
        return allEmails.some(email => isInvalidEmail(email));
    }, [attendees, payload]);

    const missingQuantity = useMemo(() => {
        let allQuantities = attendees.map(attendee => attendee.quantity);
        allQuantities.pop();
        return allQuantities.some(q => !q);
    }, [attendees, payload]);

    const noOrder = useMemo(() => {
        return attendees.length <= 1;
    }, [attendees, payload]);

    const valid = useMemo(() => {
        return !quotasExceded && messageIsValid && !missingEmails && !missingQuantity && !invalidEmails && !noOrder;
    }, [quotasExceded, messageIsValid, missingEmails, missingQuantity, invalidEmails, noOrder]);

    if (parsing) {
        return <Waiting />;
    }

    return (
        <>
            {hasQuotas && quotasExceded && <TableError quotas />}
            <div className={css['attendees-invitation-title']}>
                <span>{t('attendees.invitations.counter')}</span>

                {hasQuotas && (
                    <div className={css['attendees-invitation-title-quotas']}>
                        <>
                            <span>{t('attendees.invitations.quotas')}: </span>
                            <span className={quotasExceded ? css['invalid'] : css['valid']}>{`${totalRemaining}/${remainingQuotas}`}</span>
                        </>
                    </div>
                )}
            </div>

            <AttendeesTable />
            <EmailToggle />
            <Button primary disabled={!valid || !invitationsQuotas} label={t('ticket.common.action.validate')} onClick={handleSubmit} />
        </>
    );
});
export default AttendeesStep;
